
import {
    RouterProvider,
} from "react-router-dom";
import { Button } from "semantic-ui-react";

import { router } from "./router";
import { useVersionCheck } from "./hooks/useVersionCheck";

export default function App() {
    const { updateAvailable } = useVersionCheck();

    return (
        <>
            {updateAvailable && (
                <div style={{
                    position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1000,
                    background: "#000", color: "#fff", padding: "12px 16px",
                    display: "flex", alignItems: "center", justifyContent: "space-between",
                    gap: 12,
                }}>
                    <span>A new version is available.</span>
                    <Button size="small" primary onClick={() => window.location.reload()}>
                        Refresh
                    </Button>
                </div>
            )}
            <RouterProvider router={router} fallbackElement={<p>Initial Load...</p>} />
        </>
    );
}
